export const CATEGORIES: { value: string; label: string; color: string }[] = [
  { value: "groceries",     label: "Alimentation",          color: "#4caf50" },
  { value: "housing",       label: "Logement",              color: "#2196f3" },
  { value: "transport",     label: "Transport",             color: "#ff9800" },
  { value: "fuel",          label: "Essence",                color: "#ffc107" },
  { value: "car_maintenance", label: "Entretien véhicule",  color: "#8d6e63" },
  { value: "diy_decor",     label: "Bricolage/Décoration",  color: "#009688" },
  { value: "utilities",     label: "Factures & services",   color: "#9c27b0" },
  { value: "subscriptions", label: "Abonnements",           color: "#00bcd4" },
  { value: "health",        label: "Santé",                 color: "#f44336" },
  { value: "restaurants",   label: "Restaurants & sorties", color: "#e91e63" },
  { value: "leisure",       label: "Loisirs",               color: "#ff5722" },
  { value: "clothing",      label: "Vêtements",             color: "#795548" },
  { value: "travel",        label: "Voyages",               color: "#03a9f4" },
  { value: "education",     label: "Éducation",             color: "#3f51b5" },
  { value: "childcare",     label: "Enfants",               color: "#8bc34a" },
  { value: "insurance",     label: "Assurances",            color: "#607d8b" },
  { value: "gifts",         label: "Cadeaux",               color: "#f06292" },
  { value: "other",         label: "Autre",                 color: "#9e9e9e" },
];
